"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCohortsPage = exports.parseCohort = exports.parseAssetRedemptionsPage = exports.parseAssetRedemptionRequirement = exports.parseAssetRedemption = exports.parseAssetRewardAuditsPage = exports.parseAssetRewardAudit = exports.parseAssetRewardsPage = exports.parseAssetRewardQualification = exports.parseAssetReward = void 0;
function parseAssetReward(data) {
    const { createdAt, updatedAt, startDate, endDate, valueAmount, redemptions, qualifications, ...rest } = data;
    const ret = {
        ...rest,
        endDate: endDate ? new Date(endDate) : null,
        valueAmount: valueAmount ? parseFloat(valueAmount) : null,
        redemptions: redemptions?.map((item) => parseAssetRedemption(item)),
        qualifications: qualifications?.map((item) => parseAssetRewardQualification(item)),
    };
    if (createdAt !== undefined)
        ret.createdAt = new Date(createdAt);
    if (updatedAt !== undefined)
        ret.updatedAt = new Date(updatedAt);
    if (startDate !== undefined)
        ret.startDate = new Date(startDate);
    return ret;
}
exports.parseAssetReward = parseAssetReward;
function parseAssetRewardQualification(data) {
    const { createdAt, updatedAt, thresholdAmount, ...rest } = data;
    const ret = {
        ...rest,
        thresholdAmount: thresholdAmount ? parseFloat(thresholdAmount) : null,
    };
    if (createdAt !== undefined)
        ret.createdAt = new Date(createdAt);
    if (updatedAt !== undefined)
        ret.updatedAt = new Date(updatedAt);
    return ret;
}
exports.parseAssetRewardQualification = parseAssetRewardQualification;
function parseAssetRewardsPage(data) {
    const { assetRewards, ...rest } = data;
    return {
        ...rest,
        assetRewards: assetRewards?.map((item) => parseAssetReward(item)),
    };
}
exports.parseAssetRewardsPage = parseAssetRewardsPage;
function parseAssetRewardAudit(data) {
    const { timeStamp, ...rest } = data;
    return {
        ...rest,
        timeStamp: new Date(timeStamp),
    };
}
exports.parseAssetRewardAudit = parseAssetRewardAudit;
function parseAssetRewardAuditsPage(data) {
    const { promotionAudits, ...rest } = data;
    return {
        ...rest,
        promotionAudits: promotionAudits?.map((item) => parseAssetRewardAudit(item)),
    };
}
exports.parseAssetRewardAuditsPage = parseAssetRewardAuditsPage;
function parseAssetRedemption(data) {
    const { createdAt, updatedAt, qualifiedAt, redeemedAt, paidAt, expiresAt, assetReward, requirements, ...rest } = data;
    return {
        ...rest,
        createdAt: new Date(createdAt),
        updatedAt: new Date(updatedAt),
        qualifiedAt: qualifiedAt ? new Date(qualifiedAt) : null,
        redeemedAt: redeemedAt ? new Date(redeemedAt) : null,
        paidAt: paidAt ? new Date(paidAt) : null,
        expiresAt: new Date(expiresAt),
        assetReward: assetReward ? parseAssetReward(assetReward) : undefined,
        requirements: requirements?.map((item) => parseAssetRedemptionRequirement(item)),
    };
}
exports.parseAssetRedemption = parseAssetRedemption;
function parseAssetRedemptionRequirement(data) {
    const { createdAt, updatedAt, thresholdAmount, progress, ...rest } = data;
    const ret = {
        ...rest,
        thresholdAmount: thresholdAmount ? parseFloat(thresholdAmount) : null,
        progress: parseFloat(progress),
    };
    if (createdAt !== undefined)
        ret.createdAt = new Date(createdAt);
    if (updatedAt !== undefined)
        ret.updatedAt = new Date(updatedAt);
    return ret;
}
exports.parseAssetRedemptionRequirement = parseAssetRedemptionRequirement;
function parseAssetRedemptionsPage(data) {
    const { assetRedemptions, ...rest } = data;
    return {
        ...rest,
        assetRedemptions: assetRedemptions?.map((item) => parseAssetRedemption(item)),
    };
}
exports.parseAssetRedemptionsPage = parseAssetRedemptionsPage;
function parseCohort(data) {
    const { createdAt, updatedAt, ...rest } = data;
    return {
        ...rest,
        createdAt: new Date(createdAt),
        updatedAt: new Date(updatedAt),
    };
}
exports.parseCohort = parseCohort;
function parseCohortsPage(data) {
    const { cohorts, ...rest } = data;
    return {
        ...rest,
        cohorts: cohorts?.map((item) => parseCohort(item)),
    };
}
exports.parseCohortsPage = parseCohortsPage;
//# sourceMappingURL=serialization.js.map